import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/seguroicontratars?include=seguroincendio,seguroiparcelamento`, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/seguroicontratars/${id}?include=seguroincendio,seguroiparcelamento`, options)
    .then(response => {
      let seguroicontratar = jsona.deserialize(response.data);
      delete seguroicontratar.links;
      return seguroicontratar;
    });
}

function add(seguroicontratar) {
  const payload = jsona.serialize({
    stuff: seguroicontratar,
    includeNames: ["categories"]
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  //.post(`${url}/seguroicontratars?include=seguroincendio,seguroiparcelamento`, payload, options)
  return axios
    .post(`${url}/seguroicontratars?include=seguroincendio,seguroiparcelamento`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(seguroicontratar) {
  const payload = jsona.serialize({
    stuff: seguroicontratar,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  return axios
    .patch(`${url}/seguroicontratars/${seguroicontratar.id}?include=seguroincendio,seguroiparcelamento`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.delete(`${url}/seguroicontratars/${id}`, options);
}
function downloadPDF(tipo, arquivo) {
  return axios.get(`${url}/downloads/${tipo}/${arquivo}.pdf`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
/*
function upload(seguroicontratar, image) {
  const bodyFormData = new FormData();
  bodyFormData.append("attachment", image);

  return axios
    .post(`${url}/uploads/seguroicontratars/${seguroicontratar.id}/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  upload
};
*/
export default {
  list,
  get,
  add,
  update,
  destroy,
  downloadPDF
};